import { GraduationCap } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  clickable?: boolean;
  navigateTo?: string;
  scheduleWhite?: boolean;
}

export default function Logo({ size = 'md', clickable = true, navigateTo = '/', scheduleWhite = false }: LogoProps) {
  const navigate = useNavigate();

  const sizes = {
    sm: {
      icon: 'w-6 h-6',
      text: 'text-lg',
      container: 'space-x-2',
    },
    md: {
      icon: 'w-8 h-8',
      text: 'text-xl',
      container: 'space-x-2.5',
    },
    lg: {
      icon: 'w-10 h-10',
      text: 'text-3xl',
      container: 'space-x-3',
    },
  };

  const handleClick = () => {
    if (clickable) {
      // If navigating to the same page, scroll to top
      if (window.location.pathname === navigateTo) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
        navigate(navigateTo);
      }
    }
  };

  return (
    <div
      className={`flex items-center ${sizes[size].container} ${clickable ? 'cursor-pointer' : ''}`}
      onClick={handleClick}
    >
      <div className="relative">
        <div className="absolute inset-0 bg-primary/20 blur-xl animate-pulse" />
        <GraduationCap className={`relative ${sizes[size].icon} text-primary`} />
      </div>
      <span className={`${sizes[size].text} font-bold tracking-tight`}>
        <span className="bg-gradient-to-r from-primary via-primary to-primary/70 bg-clip-text text-transparent font-heading">
          Uni
        </span>
        <span className={`font-sans font-semibold ${scheduleWhite ? 'text-white' : 'text-foreground'}`}>
          Schedule
        </span>
      </span>
    </div>
  );
}
